import React, { useState } from "react";
import Line from "../../../assets/line2.svg";
import { FaChevronRight } from "react-icons/fa";

export default function TestimonialTwo() {
  const [activeSection, setActiveSection] = useState("DomainSearch");
  const [results, setResults] = useState({
    email: "joedelia@anymailfinder.com",
    validation: "valid",
    domain: "anymailfinder.com",
    mxRecordsFound: true,
    smtpCheck: true,
    roleBasedAddress: false,
    disposableAddress: false,
    freeAddress: false,
    confidenceScore: 95,
    AverageScoreScore: 95,
    success: true,
    message: "Domain search successful",
    timestamp: "2024-11-08 12:30:00",
    dnsRecords: "OK",
    whoisData: "Available",
    dnssec: "Enabled",
    ipAddress: "192.168.1.1",
    country: "United States",
  });

  const toggleSection = (section) => {
    if (activeSection !== section) {
      setActiveSection(section);

      if (section === "DomainSearch") {
        setResults({
          email: "joedelia@anymailfinder.com",
          validation: "valid",
          domain: "anymailfinder.com",
          mxRecordsFound: true,
          smtpCheck: true,
          roleBasedAddress: false,
          disposableAddress: false,
          freeAddress: false,
          confidenceScore: 95,
          AverageScoreScore: 95,
          success: true,
          message: "Domain search successful",
          timestamp: "2024-11-08 12:30:00",
          dnsRecords: "OK",
          whoisData: "Available",
          dnssec: "Enabled",
          ipAddress: "192.168.1.1",
          country: "United States",
        });
      } else if (section === "EmailFinder") {
        setResults({
          name: "Joe d'Elia",
          domain: "anymailfinder.com",
          email: "joedelia@anymailfinder.com",
          jobTitle: "Marketing Manager",
          location: "New York, USA",
          company: "AnyMailFinder Inc.",
          linkedInProfile: "https://linkedin.com/in/joedelia",
          confidenceScore: 98,
          AverageScoreScore: 98,
          success: true,
          message: "Email found successfully",
          timestamp: "2024-11-08 12:35:00",
          phoneNumber: "(123) 456-7890",
          address: "123 Main St, New York, NY 10001",
          website: "https://anymailfinder.com",
          socialProfiles: [
            "https://twitter.com/joedelia",
            "https://facebook.com/joedelia",
          ],
          employmentStatus: "Employed",
        });
      } else if (section === "EmailVerifier") {
        setResults({
          email: "joedelia@anymailfinder.com",
          isValid: true,
          verifiedAt: "2024-11-08",
          verificationSource: "SMTP",
          mxRecordsFound: true,
          smtpCheck: true,
          roleBasedAddress: false,
          disposableAddress: false,
          freeAddress: false,
          confidenceScore: 90,
          AverageScoreScore: 90,
          message: "Email verified successfully",
          timestamp: "2024-11-08 12:40:00",
          statusCode: 250,
          dnsCheck: true,
          blacklistCheck: false,
          riskLevel: "Low",
          securityCheck: "Passed",
          deliveryTime: "2.3 seconds",
        });
      } else if (section === "EmailVerify") {
        setResults({
          email: "joedelia@anymailfinder.com",
          isValid: true,
          verifiedAt: "2024-11-08",
          mxRecordsFound: true,
          smtpCheck: true,
          roleBasedAddress: false,
          disposableAddress: false,
          freeAddress: false,
          confidenceScore: 92,
          AverageScore: 92,
          message: "Email verification completed",
          timestamp: "2024-11-08 12:45:00",
          dnsCheck: "Passed",
          verificationMethod: "SMTP",
          disposableCheck: "No",
          riskLevel: "Moderate",
          blacklistStatus: "Not Blacklisted",
          location: "New York, USA",
          securityLevel: "High",
        });
      }
    }
  };

  return (
    <div className="bg-white py-10 lg:pb-14 lg:pt-20 px-5 flex flex-col items-center my-4">
      <div className="flex flex-col lg:flex-row w-full gap-4">
        <div className="w-full lg:w-[50%] order-2 lg:order-2">
          <div className="rounded-lg w-full">
            <div className="relative">
              <div className="flex items-center bg-[#19253C] p-4 rounded-t-xl border-b-[1px] border-gray-500">
                <span className="bg-green-500 text-white px-3 py-1 rounded-lg mr-2">
                  200 - OK
                </span>
              </div>
              <pre className="bg-[#19253C] h-[400px] text-white p-4 rounded-b-xl overflow-y-auto overflow-x-auto scrollbar-hide">
                {JSON.stringify(results, null, 2)}
              </pre>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-[50%] order-1 lg:order-1 pl-2 pr-6 lg:pr-24">
          <div className="text-left">
            <h2 className="text-3xl sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold">
              Single Search{" "}
              <span className="relative inline-block">
                API
                <img
                  src={Line}
                  alt="Underline decoration"
                  className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
                />
              </span>
            </h2>
            <div className="mt-8">
              <div
                onClick={() => toggleSection("DomainSearch")}
                className={`cursor-pointer flex justify-between items-center ${
                  activeSection === "DomainSearch"
                    ? "border-transparent pt-4"
                    : "border-b py-4"
                }`}
              >
                <span
                  className={`font-semibold text-2xl pl-2 ${
                    activeSection === "DomainSearch"
                      ? "text-black"
                      : "text-[#757C81]"
                  }`}
                >
                  Single Search by Name{" "}
                </span>
                <FaChevronRight
                  className={`transition-transform duration-200 text-[#757C81] ${
                    activeSection === "DomainSearch"
                      ? "rotate-90 !text-black"
                      : ""
                  }`}
                />
              </div>
              {activeSection === "DomainSearch" && (
                <div
                  className={`${
                    activeSection === "DomainSearch"
                      ? "border-b"
                      : "border-transparent"
                  }`}
                >
                  <p className="mt-4 text-lg text-gray-600 px-2 pb-5">
                    Provide a name, and we’ll deliver verified email addresses
                    in seconds. Perfect for targeted outreach.
                  </p>
                </div>
              )}

              <div
                onClick={() => toggleSection("EmailFinder")}
                className={`cursor-pointer flex justify-between items-center ${
                  activeSection === "EmailFinder"
                    ? "border-transparent pt-4"
                    : "border-b py-4"
                }`}
              >
                <span
                  className={`font-semibold text-2xl pl-2 ${
                    activeSection === "EmailFinder"
                      ? "text-black"
                      : "text-[#757C81]"
                  }`}
                >
                  Single Search by Domain{" "}
                </span>
                <FaChevronRight
                  className={`transition-transform duration-200 text-[#757C81] ${
                    activeSection === "EmailFinder"
                      ? "rotate-90 !text-black"
                      : ""
                  }`}
                />
              </div>
              {activeSection === "EmailFinder" && (
                <div
                  className={`${
                    activeSection === "EmailFinder"
                      ? "border-b"
                      : "border-transparent"
                  }`}
                >
                  <p className="mt-4 text-lg text-gray-600 px-2 pb-5">
                    Enter a domain to discover valid email addresses associated
                    with it. Ideal for company-wide connections.
                  </p>
                </div>
              )}

              <div
                onClick={() => toggleSection("EmailVerifier")}
                className={`cursor-pointer flex justify-between items-center ${
                  activeSection === "EmailVerifier"
                    ? "border-transparent pt-4"
                    : "border-b py-4"
                }`}
              >
                <span
                  className={`font-semibold text-2xl pl-2 ${
                    activeSection === "EmailVerifier"
                      ? "text-black"
                      : "text-[#757C81]"
                  }`}
                >
                  Single Search by Decision Maker{" "}
                </span>
                <FaChevronRight
                  className={`transition-transform duration-200 text-[#757C81] ${
                    activeSection === "EmailVerifier"
                      ? "rotate-90 !text-black"
                      : ""
                  }`}
                />
              </div>
              {activeSection === "EmailVerifier" && (
                <div
                  className={`${
                    activeSection === "EmailVerifier"
                      ? "border-b"
                      : "border-transparent"
                  }`}
                >
                  <p className="mt-4 text-lg text-gray-600 px-2 pb-5">
                    Looking for key contacts? Search by role or title to find
                    decision-makers in any organization.
                  </p>
                </div>
              )}

              <div
                onClick={() => toggleSection("EmailVerify")}
                className={`cursor-pointer flex justify-between items-center ${
                  activeSection === "EmailVerify"
                    ? "border-transparent pt-4"
                    : "border-b py-4"
                }`}
              >
                <span
                  className={`font-semibold text-2xl pl-2 ${
                    activeSection === "EmailVerify"
                      ? "text-black"
                      : "text-[#757C81]"
                  }`}
                >
                  Single Search by LinkedIn ID{" "}
                </span>
                <FaChevronRight
                  className={`transition-transform duration-200 text-[#757C81] ${
                    activeSection === "EmailVerify"
                      ? "rotate-90 !text-black"
                      : ""
                  }`}
                />
              </div>
              {activeSection === "EmailVerify" && (
                <div
                  className={`${
                    activeSection === "EmailVerify"
                      ? "border-b"
                      : "border-transparent"
                  }`}
                >
                  <p className="mt-4 text-lg text-gray-600 px-2 pb-5">
                    Input a LinkedIn profile ID and get the verified email
                    address instantly. Great for connecting with leads directly.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
